import { styled } from '@mui/material/styles'
import { Divider, Typography } from '@mui/material'
import Box, { BoxProps } from '@mui/material/Box'
import HelpOutlineIconStyled from '@mui/icons-material/HelpOutlineOutlined'
import IconButtonStyled, { IconButtonProps } from '@mui/material/IconButton'
import CloseIconStyled from '@mui/icons-material/Close'

export const Container = styled(Box)<BoxProps>(({ theme }) => ({
  backgroundColor: theme.palette.background.primary,
  flexGrow: 1,
  [theme.breakpoints.down('tablet')]: {
    width: 258
  },
  [theme.breakpoints.up('tablet')]: {
    width: 313
  },
  [theme.breakpoints.up('notebook')]: {
    width: 562
  }
}))

export const Titulo = styled(Typography)(({ theme }) => ({
  padding: '24px 16px 0 16px',
  color: theme.palette.teal?.primary,
  ...theme.typography.h5Bold
}))

export const Content = styled(Box)(() => ({
  padding: '16px',
  overflowY: 'auto',
  flexGrow: 1
}))

export const HeaderMenu = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: theme.palette.background.secondary,
  height: 56,
  paddingLeft: 18,
  paddingRight: 18,
  position: 'sticky',
  top: 0,

  div: {
    display: 'flex',
    alignItems: 'center',

    h6: {
      marginLeft: '18px',
      color: theme.palette.text.secondary,
      ...theme.typography.h6Bold
    }
  }
}))

export const DividerFixed = styled(Divider)(() => ({
  position: 'sticky',
  top: 56
}))

export const FooterMenu = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: '16px',
  justifyContent: 'space-between',
  alignItems: 'center',
  alignSelf: 'stretch',
  backgroundColor: theme.palette.background.secondary,
  p: {
    color: theme.palette.text.secondary,
    ...theme.typography.body2
  }
}))

export const HelpOutlineIcon = styled(HelpOutlineIconStyled)(({ theme }) => ({
  color: theme.palette.text.secondary
}))

export const CloseIcon = styled(CloseIconStyled)(({ theme }) => ({
  color: theme.palette.text.secondary
}))

export const IconButton = styled(IconButtonStyled)<IconButtonProps>(() => ({
  marginLeft: 'auto'
}))
